export const tabOptions = (data) => {
	return [
		{
			key: 'open',
			tab: 'Abierta',
			data: data,
			status: 'open',
		},
		{
			key: 'close',
			tab: 'Cerrada',
			data: data,
			status: 'close',
		},
	];
};
